import { render, staticRenderFns } from "./OrderFeedback.vue?vue&type=template&id=196c6388&scoped=true"
import script from "./OrderFeedback.vue?vue&type=script&lang=js"
export * from "./OrderFeedback.vue?vue&type=script&lang=js"
import style0 from "./OrderFeedback.vue?vue&type=style&index=0&id=196c6388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c6388",
  null
  
)

export default component.exports